import * as PLAYBACKS from '@hotjar/recordings/src/constants/routes/playbacks';
import * as API from './api';
import * as AUTH from './auth';
import * as CHECKOUT from './checkout';
import * as DASHBOARD_QUANTZ from './dashboard-quantz';
import * as ENGAGE_INSIGHTS from './engage-insights';
import * as FEEDBACK from './feedback';
import * as FUNNELS from './funnels';
import * as HEATMAPS from './heatmaps';
import * as HIGHLIGHTS from './highlights';
import * as MFA from './mfa';
import * as ONBOARDING from './onboarding';
import * as OVERVIEW from './overview';
import * as PERMISSION_REQUIRED from './permission-required';
import * as PROFILE from './profile';
import * as RECRUIT from './recruit';
import * as REGISTER from './register';
import * as SETTINGS from './settings';
import * as SITE from './site';
import * as SSO from './sso';
import * as STATUS from './status';
import * as SURVEY_GOALS from './survey-goals';
import * as SURVEY_TEMPLATES from './survey-templates';
import * as SURVEYS from './surveys';
import * as TEAM from './team';
import * as TRENDS from './trends';

export { API };

export { AUTH };

export { CHECKOUT };

export { DASHBOARD_QUANTZ };

export { ENGAGE_INSIGHTS };

export { FEEDBACK };

export { FUNNELS };

export { HEATMAPS };

export { HIGHLIGHTS };

export { MFA };

export { ONBOARDING };

export { OVERVIEW };

export { PERMISSION_REQUIRED };

export { PLAYBACKS };

export { PROFILE };

export { RECRUIT };

export { REGISTER };

export { SETTINGS };

export { SITE };

export { SSO };

export { STATUS };

export { SURVEY_GOALS };

export { SURVEY_TEMPLATES };

export { SURVEYS };

export { TEAM };

export { TRENDS };

// An array of all the routing config objects.
// This is to make it easier to search the configs from routing utils.
export const ALL_ROUTES = [
  ...Object.values(API),
  ...Object.values(AUTH),
  ...Object.values(CHECKOUT),
  ...Object.values(DASHBOARD_QUANTZ),
  ...Object.values(ENGAGE_INSIGHTS),
  ...Object.values(FEEDBACK),
  ...Object.values(FUNNELS),
  ...Object.values(HEATMAPS),
  ...Object.values(HIGHLIGHTS),
  ...Object.values(MFA),
  ...Object.values(ONBOARDING),
  ...Object.values(OVERVIEW),
  ...Object.values(PERMISSION_REQUIRED),
  ...Object.values(PLAYBACKS),
  ...Object.values(PROFILE),
  ...Object.values(RECRUIT),
  ...Object.values(SETTINGS),
  ...Object.values(SITE),
  ...Object.values(SSO),
  ...Object.values(STATUS),
  ...Object.values(SURVEY_GOALS),
  ...Object.values(SURVEY_TEMPLATES),
  ...Object.values(SURVEYS),
  ...Object.values(TEAM),
  ...Object.values(TRENDS),
];
